/**
 * ConsentGate — Shown when access to history is blocked by client consent settings.
 *
 * Centred column: lock icon + title + body text.
 * Used by AnalysisHistoryCard when canViewHistory = false.
 */

import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import type { TFunction } from '@dramadetector/shared';

type ConsentGateType = 'history' | 'original_text' | 'chat';

interface ConsentGateProps {
  type: ConsentGateType;
  clientName: string;
  t: TFunction<'practitioner'>;
}

export const ConsentGate: React.FC<ConsentGateProps> = ({ type, clientName: _clientName, t }) => (
  <View style={styles.container} accessible={true}>
    <Ionicons name="lock-closed" size={28} color="#9CA3AF" />
    <Text style={styles.title}>{t(`consent_gate.${type}.title` as never)}</Text>
    <Text style={styles.body}>{t(`consent_gate.${type}.body` as never)}</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 32,
    gap: 10,
  } as ViewStyle,
  title: {
    fontSize: 15,
    fontWeight: '700',
    color: '#374151',
    textAlign: 'center',
  },
  body: {
    fontSize: 13,
    color: '#6B7280',
    textAlign: 'center',
    lineHeight: 18,
  },
});
